import React from 'react';
import { Link } from 'react-router-dom';

import { Col, Row, Layout } from "antd";
import cruLogo from "../../assets/img/cru_logo.png";
import diamindLogo from "../../assets/img/diamind_logo.png";
import actLogo from "../../assets/img/act_quicr_logo.png"
import settingsIcon from "../../assets/img/settings.png"

import styles from './Footer.css';

const Footer = (props) => {
    return (
        <Layout.Footer>
            <Row type="flex" align="middle" justify="center">
                <Col md={12} sm={24}>
                    <Row>
                        <Col lg={24}>
                            <a href="/"><img alt="act" src={actLogo} style={{ objectFit: 'contain', width: '20%', minWidth: 150, height: 'auto' }} /></a>
                            <a href="https://www.cru.ucalgary.ca" target="_blank" rel="noopener noreferrer"><img alt="cru" src={cruLogo} style={{ objectFit: 'contain', width: '20%', minWidth: 150, height: 'auto' }} /></a>
                            <a href="https://www.diamindsolutions.ca" target="_blank" rel="noopener noreferrer"><img alt="diamind" src={diamindLogo} style={{ objectFit: 'contain', width: '20%', minWidth: 200, height: 'auto', marginTop: 20 }} /></a>

                        </Col>
                    </Row>
                </Col>
                <Col md={12} sm={24}>
                    <span style={{ float: 'right' }}>© 2020 | <a href="https://www.diamindsolutions.ca" target="_blank" rel="noopener noreferrer" style={{ color: '#000000' }}> Diamind Solutions Inc. </a> | <a href="https://www.cru.ucalgary.ca" target="_blank" rel="noopener noreferrer" style={{ color: '#000000' }}> Clinical Research Unit </a>, University of Calgary, Cumming School of Medicine </span>
                </Col>
            </Row>

            {!props.noAdminLink && <Link to="/admin/dashboard" className={styles.settingsLink}><img alt="admin" src={settingsIcon} style={{ width: '28px', height: '28px' }} /></Link>}

        </Layout.Footer>
    );

};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js